import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { useEffect, useState } from "react";

import { ErrorModal } from "@/components/shared/modal/error-modal";
import { Outlet } from "react-router-dom";
import { usePartsContext } from "../parts/context/PartsContext";
import { getParts } from "../parts/repositories/PartsRepository";
import { useRootTypeContext } from "../rootTypes/context/RootTypeContext";
import { getRootTypes } from "../rootTypes/repositories/RootTypes";
import { TableComponentTypes } from "./components/DataTable/TableComponentTypes";
import { useComponentTypesContext } from "./context/ComponentTypeContext";
import { getComponentTypes } from "./repositories/ComponentTypes";

export const ComponentTypes = () => {
	const { state, actions } = useComponentTypesContext();
	const { actions: rootActions } = useRootTypeContext();
	const { actions: partActions } = usePartsContext();

	const [isLoading, setIsLoading] = useState(true);
	const [fetchDataError, setFetchDataError] = useState<string | null>(null);

	const getComponentTypesFromAPI = async () => {
		setIsLoading(true);

		const values = await Promise.all([
			getParts(),
			getRootTypes(),
			getComponentTypes(),
		])
			.then((r) => {
				const [
					{ ok: partsOk, data: parts },
					{ ok: rootOk, rootTypes },
					{ ok: componentOk, componentTypes },
				] = r;

				if (componentOk && rootOk && partsOk) {
					actions.setComponentTypes(componentTypes);
					rootActions.setRootTypes(rootTypes);
					partActions.setParts(parts?.data);
					setIsLoading(false);
				}
			})
			.catch((e) => {
				setFetchDataError(e);
			});
	};

	useEffect(() => {
		getComponentTypesFromAPI();
	}, []);

	if (state.componentTypes) {
		return (
			<>
				<Grid container justifyContent="center" alignItems="center">
					<Grid item md={12} xs={12} style={{ margin: "20px" }}>
						<Paper
							elevation={1}
							style={{
								width: "100%",
								padding: "10px 0 50px",
								borderRadius: "0.75rem",
							}}
						>
							<TableComponentTypes
								isLoading={isLoading}
								getComponentTypesFromAPI={getComponentTypesFromAPI}
							/>
						</Paper>
						<Outlet />
					</Grid>
				</Grid>
				<ErrorModal
					onHide={() => setFetchDataError(null)}
					error={fetchDataError}
					size={"xs"}
				/>
			</>
		);
	}
	return <></>;
};
